import React from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useUserSession } from '@investigator/shared/hooks';

const INACTIVITY_LIMIT = 15 * 60 * 1000; // 15 minutes

export const IdleLogout: React.FC = () => {
  const { signOut } = useUserSession();

  const onIdle = async () => {
    await signOut();
    window.location.href = '/login';
  };

  useIdleTimer({
    timeout: INACTIVITY_LIMIT,
    onIdle,
    debounce: 500,
    events: ['mousemove', 'keydown', 'mousedown', 'scroll', 'touchstart'],
    crossTab: true,
  });

  return null;
};
